export default __webpack_public_path__ + "static/media/lock.548c5212.svg";